import "./register.css";
import { useFormik } from "formik";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import NavBar from "../common/navBar/navBar";
import Footer from "../common/footer/footer";
import { signUp } from "../common/api/authUser";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function Register() {
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const navigate = useNavigate();
  const newUser = async (form_data) => {
    const res = await signUp(form_data);
    if (res && res.data.responseCode === 201) {
      toast.success(res.data.resMessage);
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } else if (res && res.data.responseCode === 400) {
      toast.error(res.data.errMessage);
    } else {
      toast.error("Something went wrong...");
    }
    return res;
  };

  const formik = useFormik({
    initialValues: {
      username: "",
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.username) {
        errors.username = "Input username";
      } else if (values.username.length < 3) {
        errors.username = "Must be at least 3 characters";
      } else if (values.username.length > 20) {
        errors.username = "Must be 20 characters or less";
      }
      if (!values.name) {
        errors.name = "Input name";
      }
      if (!values.email) {
        errors.email = "Input email";
      }
      if (!values.password) {
        errors.password = "Input password";
      } else if (values.password.length < 6) {
        errors.password = "Must be at least 6 characters";
      } else if (values.password.length > 20) {
        errors.password = "Must be 20 characters or less";
      }
      if (!values.confirmPassword) {
        errors.confirmPassword = "Input confirm password";
      } else if (values.confirmPassword !== values.password) {
        errors.confirmPassword = "Passwords do not match";
      }
      return errors;
    },

    onSubmit: async function (values, action) {
      await newUser(values);
      action.resetForm();
    },
  });
  return (
    <>
      <NavBar />
      <div className="container text-center register-form-container position-relative z-0">
        <div className="row">
          <div className="col col-12 mt-5 col-md-6">
            <h1
              className="heading mt-3 mb-3 fs-1 fw-bold"
              style={{ color: "#2B3654" }}
            >
              Join DevDiaries Today
            </h1>
            <p className="fs-4">Empower Your Coding Journey!</p>
            <p className="me-5 ms-5 text-muted">
              We’re thrilled to have you join our growing community of
              passionate developers, coders, and tech enthusiasts. At
              DevDiariesBlog, we believe that coding is not just about writing
              lines of code—it's about learning, growing, and sharing
              experiences with like-minded individuals.By becoming a part of our
              community, you’re not just getting access to expert insights and
              tutorials but also becoming a valued contributor to a
              collaborative space where knowledge is freely exchanged. Whether
              you're a seasoned professional or just beginning your journey in
              development, DevDiariesBlog has something for everyone.
            </p>
            <p className="me-5 ms-5 text-muted ">
              Explore in-depth articles, engage in thought-provoking
              discussions, and discover coding tips and tricks tailored to your
              learning needs. Our mission is to empower you with the tools and
              knowledge to take your skills to the next level. So, dive in,
              connect with others, and let’s code, learn, and innovate together.
              Your development journey starts here—and we’re excited to be part
              of it with you!
            </p>
          </div>
          <div className="col col-12 col-md-6">
            <form
              className="container register-form"
              onSubmit={formik.handleSubmit}
            >
              <div className="register">
                <h1 className="text-center mb-4" style={{ color: "#1E4682" }}>
                  Register
                </h1>
              </div>

              <div>
                <label htmlFor="username">User Name</label>
                <input
                  type="text"
                  className={
                    formik.errors.username && formik.touched.username
                      ? "border border-danger register_input  w-100 p-2 "
                      : " border register_input  w-100 p-2"
                  }
                  id="username"
                  name="username"
                  autoComplete="username"
                  placeholder="Enter your User Name"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              {formik.errors.username && formik.touched.username ? (
                <p className="form-error mt-0">{formik.errors.username}</p>
              ) : null}

              <div>
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  className={
                    formik.errors.name && formik.touched.name
                      ? "border border-danger register_input  w-100 p-2 "
                      : " border register_input  w-100 p-2"
                  }
                  id="name"
                  name="name"
                  autoComplete="name"
                  placeholder="Enter your Name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              {formik.errors.name && formik.touched.name ? (
                <p className="form-error mt-0">{formik.errors.name}</p>
              ) : null}

              <div>
                <label htmlFor="email">Email address</label>
                <input
                  type="email"
                  className={
                    formik.errors.email && formik.touched.email
                      ? "border border-danger register_input  w-100 p-2 "
                      : " border register_input  w-100 p-2"
                  }
                  id="email"
                  name="email"
                  placeholder="Enter your email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              {formik.errors.email && formik.touched.email ? (
                <p className="form-error mt-0">{formik.errors.email}</p>
              ) : null}

              <div>
                <label htmlFor="password">Password</label>
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className={
                      formik.errors.password && formik.touched.password
                        ? "border border-danger register_input  w-100 p-2 "
                        : " border register_input  w-100 p-2"
                    }
                    id="password"
                    name="password"
                    autoComplete="new-password"
                    placeholder="Enter your password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  <FontAwesomeIcon
                    icon={showPassword ? faEyeSlash : faEye}
                    className="eye-position"
                    onClick={togglePasswordVisibility}
                  />
                </div>
              </div>
              {formik.errors.password && formik.touched.password ? (
                <p className="form-error mt-0">{formik.errors.password}</p>
              ) : null}

              <div>
                <label htmlFor="confirmPassword">Confirm Password</label>

                <input
                  type="password"
                  className={
                    formik.errors.confirmPassword &&
                    formik.touched.confirmPassword
                      ? "border border-danger register_input  w-100 p-2 "
                      : " border register_input  w-100 p-2"
                  }
                  id="confirmPassword"
                  name="confirmPassword"
                  autoComplete="current-password"
                  placeholder="Confirm your password"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              {formik.errors.confirmPassword &&
              formik.touched.confirmPassword ? (
                <p className="form-error mt-0">
                  {formik.errors.confirmPassword}
                </p>
              ) : null}

              <button type="submit" className="btn btn-submit mt-3">
                Register
              </button>
              <div className="para">
                <p>
                  Do you already have an account??
                  <Link to="/login" style={{ textDecoration: "none" }}>
                    Login Now
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
      <footer>{<Footer />}</footer>
    </>
  );
}
export default Register;
